/* eslint-disable max-len */
/* eslint-disable vue/max-len */

import * as pbm from '@/grpc-gen/giftcard_pb';
import * as pbs from '@/grpc-gen/giftcards_service_pb';
import { dateFromDateString, dateFromDateTimeString, unixFromDate } from '@/services/time-utils';
import { ContactMapping } from '@/model/Contact';
import Currency from './currency';
import GiftcardTransaction, { GiftcardTransactionMapping } from './giftcard-transaction';
import Contact from './contact';
import GiftcardRecipient from './giftcard-recipient';

export interface GiftcardMapping extends GiftcardTransactionMapping, ContactMapping {
}

export default class Giftcard {
  id: number = 0;

  title?: string;

  description?: string;

  backgroundImageUrl?: string;

  serviceId?: number = 0;

  locale?: string;

  balance: number = 0;

  currency: string = '';

  status: string = '';

  code: string = '';

  color?: string;

  dtCreate?: Date;

  dtUpdate?: Date;

  dtExpiry?: Date;

  price?: number;

  showLogo?: boolean;

  contact?: Contact;

  recipient?: GiftcardRecipient;

  transactions: GiftcardTransaction[] = [];

  isExpired?: boolean;

  issuedBy?: string;

  issuedByAccountId?: number;

  issuedByAccountName?: string;

  static fromGrpcResponse(r: pbs.GiftcardsGiftcardResponse, m?: GiftcardMapping): Giftcard {
    return Giftcard.fromGrpcModel(r.giftcard, m);
  }

  static fromGrpcModel(o?: pbm.Giftcard, m?: GiftcardMapping): Giftcard {
    const p = new Giftcard();

    p.id = Number(o?.id ?? 0);
    p.title = o?.title || undefined;
    p.description = o?.description || undefined;
    p.backgroundImageUrl = o?.backgroundImageUrl || undefined;
    p.serviceId = Number(o?.serviceId ?? 0) || undefined;
    p.locale = o?.locale || undefined;
    p.balance = o?.balance ?? 0;
    p.currency = o?.currency ?? '';
    p.status = o?.status ?? '';
    p.code = o?.code ?? '';
    p.color = o?.color || undefined;
    p.dtCreate = o?.dtCreate ? new Date(Number(o.dtCreate) * 1000) : undefined;
    p.dtUpdate = o?.dtUpdate ? new Date(Number(o.dtUpdate) * 1000) : undefined;
    // p.dtExpiry = o?.getDtExpiry() ? new Date(o.getDtExpiry() * 1000) : undefined;
    p.price = o?.price || undefined;
    p.showLogo = o?.showLogo || undefined;

    p.recipient = o?.recipient ? GiftcardRecipient.fromGrpcModel(o.recipient, m) : undefined;
    p.contact = o?.contact ? Contact.fromGrpcModel(o.contact, m) : undefined;
    p.transactions = (o?.transactions ?? []).map((t) => GiftcardTransaction.fromGrpcModel(t, m));

    p.isExpired = o?.isExpired || undefined;
    p.dtExpiry = dateFromDateString(o?.dtExpiryMil) ?? undefined;

    p.issuedByAccountId = Number(o?.issuedByAccountId ?? 0) || undefined;
    p.issuedByAccountName = o?.issuedByAccountName || undefined;

    return p;
  }
}
